module.exports = __webpack_public_path__ + "img/bot-chip-error-badge.98ca156f.svg";